export class UserInfo {
  constructor(
    public id: string,
    public email: string,
    public firstName: string,
    public lastName: string,
    public role: string,
    public affiliation?: string,
    public uiTheme?: 'SYSTEM' | 'LIGHT' | 'DARK',
  ) {}

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }
  get initials(): string {
    const firstInitial = this.firstName ? this.firstName.charAt(0).toUpperCase() : '';
    const lastInitial = this.lastName ? this.lastName.charAt(0).toUpperCase() : '';
    return `${firstInitial}${lastInitial}`;
  }
}
